
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { EntiteUtilisateurModel } from 'src/models/selectionEntiteUtilisateurModel';
import { UtilisateurService } from 'src/services/utilisateur.service';

@Component({
    selector: 'app-selection-entite-card',
    templateUrl: './selection-entite-card.component.html',
    styleUrls: ['./selection-entite-card.component.scss'],
    imports: [TranslateModule, MatIconModule]
})
export class SelectionEntiteCardComponent {

  @Input() entiteUtilisateur!: EntiteUtilisateurModel;
  @Output() cardClick = new EventEmitter<EntiteUtilisateurModel>();

  onCardClick() {
    this.cardClick.emit(this.entiteUtilisateur);
  }

  constructor(public utilisateurService: UtilisateurService) { }

  getRole(): string {
    if(this.entiteUtilisateur.roleEntites.some(r => r.roleId === 1)) {
      return 'PILOTE';
    } else if(this.entiteUtilisateur.roleEntites.some(r => r.roleId === 2)) {
      return 'ADMIN';
    } else if(this.entiteUtilisateur.roleEntites.some(r => r.roleId === 3)) {
      return 'UTILISATEUR';
    }
    return 'UTILISATEUR';
  }

}
